import React, { useEffect, useState } from "react";
import styled from "styled-components";
import MembershipSelectionCard from "./MembershipSelectionCard";
import { serverLine } from "../../../../controllers/network/serverLine";
import LoadingSection from "../../../helperComponents/LoadingSection";
import LoggedInMembershipPlanCard from "../membership/LoggedInMembershipPlanCard";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 0;
  margin-bottom: 20px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const PlanFeatures = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 200px;
`;

const PlanFeature = styled.div`
  margin-bottom: 5px;
  display: flex;

  &::before {
    height: 25px;
    width: 25px;
    content: "✓";
    background-color: var(--surface2);
    color: var(--element);
    border-radius: 100px;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    margin-top: -3px;
  }
`;

const MembershipSelection = ({ value, onChange }) => {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    serverLine.get("/membership-plans").then(setPlans);
  }, []);

  if (!plans)
    return (
      <Container>
        <LoadingSection />
      </Container>
    );

  return (
    <Container>
      {plans.map((item, index) => {
        if (item.status == "DISABLED") return null;
        return (
          <LoggedInMembershipPlanCard
            validityInWeeks={item.validityInWeeks}
            membershipPlanID={item._id}
            loadStuff={null}
            key={index}
            title={item.name}
            setLoading={null}
            desc={item.description}
            price={item.price}
            name={item.name.toUpperCase()}
            features={
              <PlanFeatures>
                <PlanFeature>{item.feature1}</PlanFeature>
                <PlanFeature>{item.feature2}</PlanFeature>
                <PlanFeature>{item.feature3}</PlanFeature>
                {item.feature4 ? (
                  <PlanFeature>{item.feature4}</PlanFeature>
                ) : null}
              </PlanFeatures>
            }
          />
        );
      })}
    </Container>
  );
};

export default MembershipSelection;
